export interface AppSettings {
  fontScale: number;
  motion: "system" | "reduce";
}

export type SettingsStorage = Pick<Storage, "getItem" | "setItem">;

export function validFontScale(value: unknown): number {
  const number = Number(value);
  return Number.isFinite(number) && number >= 80 && number <= 150
    ? Math.round(number / 5) * 5 : 100;
}

export function loadAppSettings(storage: Pick<Storage, "getItem">): AppSettings {
  try {
    return {
      fontScale: validFontScale(storage.getItem("party-stack-font-scale")),
      motion: storage.getItem("party-stack-reduced-motion") === "reduce" ? "reduce" : "system",
    };
  } catch { return { fontScale: 100, motion: "system" }; }
}

export function saveAppSettings(storage: SettingsStorage, settings: AppSettings): void {
  storage.setItem("party-stack-font-scale", String(validFontScale(settings.fontScale)));
  storage.setItem("party-stack-reduced-motion", settings.motion === "reduce" ? "reduce" : "system");
}

// A settings draft never writes to storage until Save. Cancel restores the live appearance.
export class AppSettingsDraft {
  readonly original: AppSettings;
  value: AppSettings;
  constructor(settings: AppSettings, private readonly preview: (settings: AppSettings) => void) {
    this.original = { ...settings };
    this.value = { ...settings };
  }
  update(settings: Partial<AppSettings>) {
    this.value = { ...this.value, ...settings };
    this.value.fontScale = validFontScale(this.value.fontScale);
    this.preview(this.value);
  }
  cancel() { this.preview(this.original); }
  save(storage: SettingsStorage): AppSettings {
    saveAppSettings(storage, this.value);
    return { ...this.value };
  }
}
